import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    // Auth endpoints (login / OTP / forgot-password) handle their own 401s —
    // the invalid-credentials error must stay on screen. Reloading here wiped
    // the message a split second after it appeared.
    const isAuthCall = (err.config?.url || '').includes('/auth/');
    if (err.response?.status === 401 && !isAuthCall) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      const reason = err.response?.data?.reason;
      if (reason === 'another_session') {
        sessionStorage.setItem('logout_reason', 'another_session');
      }
      window.location.href = '/login';
    } else if (err.response?.status === 403) {
      // Lazy import to avoid circular dep
      import('../components/Toast').then(m => m.toast.error('Access denied — insufficient permissions'));
    } else if (err.response?.status >= 500) {
      import('../components/Toast').then(m => m.toast.error('Server error: ' + (err.response?.data?.error || 'Unknown error')));
    }
    return Promise.reject(err);
  }
);

export default api;
